import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { ChemistryResult } from "../models/ChemistryResult";
import { ChemistrySample } from "../models/ChemistrySample";

//ChemistrySamples
export const getChemistrySamples = async (
	heatId: number,
	statusCode: string | null,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "HeatId", value: heatId });
	parameters.push({ name: "StatusCode", value: statusCode });
	const resp = await apiService.callV2(
		"[LAB].[GetChemistrySamples]",
		parameters,
	);
	return resp;
};
export const upsertChemistrySample = async (model: ChemistrySample) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	parameters.push({ name: "Id", value: model.Id });
	parameters.push({ name: "SampleTypeId", value: model.SampleTypeId });
	parameters.push({ name: "SampleSequence", value: model.SampleSequence });
	parameters.push({ name: "DateTimeResults", value: model.DateTimeResults });
	parameters.push({ name: "StatusCode", value: model.StatusCode });
	parameters.push({ name: "ResultSourceId", value: model.ResultSourceId });
	parameters.push({ name: "Comments", value: model.Comments });
	parameters.push({ name: "HeatId", value: model.HeatId });
	parameters.push({ name: "Technician", value: model.Technician });
	parameters.push({ name: "Melter", value: model.Melter });

	const resp = await apiService.callV2(
		"[LAB].[UpsertChemistrySample]",
		parameters,
	);
	return resp;
};

//ChemistryResults
export const upsertChemistryResult = async (model: ChemistryResult) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	parameters.push({
		name: "ChemistrySampleId",
		value: model.ChemistrySampleId,
	});
	parameters.push({ name: "ElementId", value: model.ElementId });
	parameters.push({ name: "Value", value: model.Value });

	const resp = await apiService.callV2(
		"[LAB].[UpsertChemistryResult]",
		parameters,
	);
	return resp;
};

// Get sample attributes by ChemistrySampleId
export const getChemistrySampleAttributes = async (
	chemistrySampleId: number,
	heatId: number,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "HeatId", value: heatId });
	parameters.push({ name: "StatusCode", value: null });

	const resp = await apiService.callV2(
		"[LAB].[GetChemistrySamples]",
		parameters,
	);

	if (resp.ok && resp.data && resp.data.tables[0]?.rows) {
		// Find the sample with matching ChemistrySampleId
		const sample = resp.data.tables[0].rows.find(
			(s: any) => s.ChemistrySampleId === chemistrySampleId,
		);
		if (sample) {
			return {
				ok: true,
				data: {
					tables: [
						{
							rows: [sample],
						},
					],
				},
			};
		}
	}

	return {
		ok: false,
		message: "Sample not found",
	};
};

// Delete ChemistrySample
export const deleteChemistrySample = async (
	ChemistrySampleId: number | null,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({
		name: "ChemistrySampleId",
		value: ChemistrySampleId ?? null,
	});

	const resp = await apiService.callV2(
		"[LAB].[DeleteChemistrySample]",
		parameters,
	);

	if (resp.ok) {
		return {
			ok: true,
			data: resp.data,
		};
	} else {
		return {
			ok: false,
			message: resp.message,
		};
	}
};
